import { Deserializable } from '../deserializable';

export class ProductEPCRating implements Deserializable {
  public ProductID: number;
  public EnergyRatingCode: string;
  public Value: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    delete (this as any).$id;

    return this;
  }
}
